import { Box, Button, Divider, Link, Typography } from "@mui/material";
import CategorySlider from "../../../../../components/guest/Aside/Categories";
import Testimonials from "../../../../../components/guest/Aside/Testimonials";
import PopularPosts from "../../../../../components/guest/Aside/Popular";
import SkeletonImage from "../../../../../components/ui/SkeletonImage";
import Images from "../../../../../assets/js/Images";
import { Link as NavLink } from "react-router-dom";
import { Fragment } from "react";

function Aside() {
  return (
    <Fragment>
      <Box textAlign="center">
        <Button
          variant="contained"
          sx={{
            width: "100%",
            maxWidth: "220px",
            justifyContent: "center",
          }}
        >
          Add Question
        </Button>
      </Box>

      <Box>
        <Typography
          fontSize={28}
          fontWeight="700"
          textAlign="center"
          color="other.color1"
        >
          Popular Posts
        </Typography>
        <Divider
          sx={{
            mt: 2,
            mb: 5,
            mx: "auto",
            maxWidth: "200px",
            borderWidth: "1.5px",
            borderColor: "secondary.main",
          }}
        />
        <PopularPosts />
      </Box>

      <Box>
        <Typography
          fontSize={28}
          fontWeight="700"
          textAlign="center"
          color="other.color1"
        >
          Categories
        </Typography>
        <Divider
          sx={{
            mt: 2,
            mb: 5,
            mx: "auto",
            maxWidth: "200px",
            borderWidth: "1.5px",
            borderColor: "secondary.main",
          }}
        />
        <CategorySlider />
      </Box>

      <Box>
        <Typography
          fontSize={28}
          fontWeight="700"
          textAlign="center"
          color="other.color1"
        >
          Testimonials
        </Typography>
        <Divider
          sx={{
            mt: 2,
            mb: 5,
            mx: "auto",
            maxWidth: "200px",
            borderWidth: "1.5px",
            borderColor: "secondary.main",
          }}
        />
        <Testimonials />
      </Box>

      <Box>
        <Box
          sx={{
            mt: 5,

            aspectRatio: "1/0.9",
          }}
        >
          <Link
            sx={{
              height: "100%",
              display: "inline-block",
              width: "100%",
              margin: "auto",
            }}
            component={NavLink}
            to="/help-center"
          >
            <SkeletonImage
              sx={{
                objectFit: "contain",
              }}
              src={Images.asideContactus}
            />
          </Link>
        </Box>
      </Box>
    </Fragment>
  );
}

export default Aside;
